import name from './name'

const selectSliceData = state => state[name]

const selectLoading = state => selectSliceData(state).loading

const selectResults = state => {
  const sliceData = selectSliceData(state)
  return {
    isVisible: sliceData.isVisible,
    total: sliceData.total,
    successCount: sliceData.successCount,
    errorsCount: sliceData.errorsCount,
    warningsCount: sliceData.warningsCount
  }
}

const selectReportUrl = state => selectSliceData(state).reportUrl

export {
  selectLoading,
  selectResults,
  selectReportUrl
}
